module.exports = __webpack_public_path__ + "img/wappr.c2616c01.svg";